module.exports = __webpack_public_path__ + "media/images/svg/quotation_solid-ed1cdf7f90ebbcf8ba6d27fd1b9743b8.svg";